/* Cases where it wouldn't be a pixel value
    - height is `initial`
    - width is `100%`
    - Any CSSWidthType or CSSHeightType values
*/

export const getPixelValue = value => {
  if (value === '100%' || value === 'initial') {
    return value;
  }

  if (value.endsWith('px')) {
    return value;
  }

  return `${value.replace(/\D/g, '')}px`;
};
